import React, { useState } from 'react';
import BOM from "@system/config/bom";
import alertic from 'src/assets/images/yellow-alert.png';
import { useBOMStore } from 'src/hooks/bom';
import System from 'src/helper/system';
import { useAxiosIndicatorCheck } from "../../../store/hook/useAxiosIndicatorCheck";

const CreatePartPopup = (props) => {
    const [__check] = useAxiosIndicatorCheck();
    const { data, SetStatus } = props;
    const [partList, setPartList] = useState([]);
    const [partListError, setPartListError] = useState(false);
    const [{ }, { get_all_bom_detail_by_bom_id_with_type_based_on_bom_tab_ui }, { create_part_list }] = useBOMStore();

    const bom_id = System.getParams().bomId;
    const add_from = data?.addFrom;

    const onHide = () => {
        SetStatus(false);
    };

    const parsePartListText = (value = '') => {
        const itemSeparator = '\n';
        const tabSeparator = '\t';
        const commaSeparator = ',';
        const finalData = [];

        const processEntry = (entry, separator) => {
            const [partNumber, quantity] = entry.split(separator).map(str => str.trim());
            if (partNumber) {
                finalData.push({
                    partNumber,
                    quantity: quantity && parseInt(quantity) || null,
                    LifeCycleRisk: '',
                    itemNumber: '',
                    erpItemNumber: ''
                });
            }
        };

        value.split(itemSeparator).forEach(entry => {
            if (entry.includes(tabSeparator)) {
                processEntry(entry, tabSeparator);
            } else if (entry.includes(commaSeparator)) {
                processEntry(entry, commaSeparator);
            } else if (entry.trim()) {
                finalData.push({
                    partNumber: entry.trim(),
                    LifeCycleRisk: '',
                    itemNumber: '',
                    erpItemNumber: ''
                });
            }
        });

        setPartList(finalData);
    };
    const onAddParts = async () => {
        if (!partList.length) {
            setPartListError(true);
            return;
        }

        const param = {
            bomIds: bom_id || localStorage.getItem(System.storageName.GUEST_BOM_ID),
            partList
        };

        const createPartLists = await create_part_list(param);

        if (createPartLists?.data) {
            if (bom_id) {
                await get_all_bom_detail_by_bom_id_with_type_based_on_bom_tab_ui(bom_id, true);
                onHide();
            } else {
                window.location.href = BOM.getBomDetailByIdRouteURL(
                    createPartLists.data.bomId,
                    { go: System.getParams().go, addFrom: add_from }
                );
            }
        }
    };

    return (
        <div className="avnet-modal avnet-modal-right">
            <div className="avnet-modal-inner">
                <button type="button" className="close py-2" onClick={onHide}>×</button>
                <div className="modal-header">
                    <h4 className="modal-title text-center font-24 lh-sm" id="myModalLabel">{data?.title}</h4>
                </div>
                <div className="modal-body addmultiplepart">
                    {partListError && (
                        <div className="alert alert-danger">
                            <span>There is nothing to submit, please try entering data again.</span>
                            <img className="ms-auto" src={alertic} alt="Alert icon" />
                        </div>
                    )}

                    <p className="mb-0 mt-2 font-arial"><b>Copy and Paste or type in up to 100 part numbers using the following format:</b></p>
                    <p className="mb-0 mt-0 lh-sm font-arial">PART # (COMMA) QUANTITY</p>
                    <p className="mt-0 lh-sm font-arial">EG.( 2N222,250 )</p>
                    <p className="mb-3 mt-3 font-arial">Note: For the part numbers that includes a comma, please use TAB between part # and quantity instead of a comma.</p>
                    <p className="mb-3 mt-3 font-arial">For <b>Customer Part Numbers (CPN)</b>, please use the Upload File feature</p>
                    <div className="form-group mb-4">
                        <textarea className="form-control create-part-textarea" rows="5" onChange={e => parsePartListText(e.target.value)} placeholder="LM324, 250&#10;LM324ADG, 750&#10;BAV99"></textarea>
                    </div>

                    <div className="text-center">
                        <button type="button" className="bs5 btn btn-secondary me-2 w120" onClick={onHide}>Close</button>
                        <button type="button" className="bs5 btn btn-primary w120" onClick={e => __check(['BOM_OPERATION_API_CALL']).status ? e.preventDefault() : onAddParts()}>
                            {__check(['BOM_OPERATION_API_CALL']).status ? <i className="fa fa-spinner fa-spin" /> : 'ADD PARTS'}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default CreatePartPopup;
